import { analytics } from '../modules/analytics';
import { clearForNextPerson } from '../storage/deviceStorage';

const localStorageStore = {
  setItem: (key: string, value: string) => {
    try {
      // eslint-disable-next-line no-restricted-globals -- legacy: the wrapper the remaining legacy keys go through, until the backend asks retire them
      localStorage.setItem(key, value);
    } catch (e) {
      console.error("Error saving to localStorage", e);
    }
  },
  getItem: (key: string) => {
    try {
      // eslint-disable-next-line no-restricted-globals -- legacy: the wrapper the remaining legacy keys go through, until the backend asks retire them
      return localStorage.getItem(key);
    } catch (e) {
      console.error("Error getting data from localStorage", e);
      return null;
    }
  },
  removeItem: (key: string) => {
    try {
      // eslint-disable-next-line no-restricted-globals -- legacy: the wrapper the remaining legacy keys go through, until the backend asks retire them
      localStorage.removeItem(key);
    } catch (e) {
      console.error("Error removing data from localStorage", e);
    }
  },
  clear: () => {
    try {
      // eslint-disable-next-line no-restricted-globals -- legacy: the wrapper the remaining legacy keys go through, until the backend asks retire them
      localStorage.clear();
    } catch (e) {
      console.error("Error clearing localStorage", e);
    }
  },
  logout: () => {
    clearForNextPerson();
    analytics.reset();
  },
};

export default localStorageStore;
